import * as React from 'react';

interface CloseOutlinedIconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string;
  width?: number;
  height?: number;
}

export const ExpressIcon: React.FC<CloseOutlinedIconProps> = ({width = 16, height = 16, ...props}) => (
  <svg width={width} height={height} viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M15.5 8.5C15.5 12.6421 12.1421 16 8 16C3.85786 16 0.5 12.6421 0.5 8.5C0.5 4.35786 3.85786 1 8 1C12.1421 1 15.5 4.35786 15.5 8.5Z"
      fill="url(#paint0_linear_1129_45469)"
      stroke="white"
    />
    <path
      d="M11.8298 8.37835L6.82984 13.7355C6.77685 13.792 6.70691 13.8298 6.63057 13.8431C6.55423 13.8564 6.47563 13.8446 6.40664 13.8093C6.33764 13.774 6.28199 13.7172 6.24809 13.6476C6.21418 13.5779 6.20386 13.4991 6.21868 13.423L6.87314 10.1493L4.30038 9.18326C4.24512 9.16259 4.19585 9.12856 4.15696 9.0842C4.11807 9.03984 4.09077 8.98654 4.07751 8.92906C4.06424 8.87157 4.06542 8.8117 4.08094 8.75479C4.09646 8.69787 4.12584 8.64569 4.16645 8.6029L9.16645 3.24576C9.21943 3.18921 9.28937 3.15143 9.36571 3.13812C9.44206 3.12481 9.52065 3.13669 9.58965 3.17197C9.65865 3.20725 9.71429 3.26401 9.7482 3.33369C9.78211 3.40338 9.79243 3.48219 9.77761 3.55826L9.12136 6.83549L11.6941 7.80022C11.749 7.82103 11.7978 7.85502 11.8364 7.89921C11.875 7.94339 11.9021 7.99639 11.9154 8.05354C11.9286 8.11069 11.9276 8.17022 11.9123 8.22687C11.8971 8.28351 11.8682 8.33554 11.8281 8.37835H11.8298Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1129_45469"
        x1="1.14286"
        y1="7.35714"
        x2="14.2857"
        y2="8.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF003D" />
        <stop offset="1" stop-color="#FF5C83" />
      </linearGradient>
    </defs>
  </svg>
);
